class MaDoctorSpotlight extends HTMLElement {
  connectedCallback() {
    if (this.dataset.maReady === 'true') return;

    this.cards = Array.from(this.querySelectorAll('[data-doctor-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-doctor-panel]'));
    if (!this.cards.length || !this.panels.length) return;

    this.dataset.maReady = 'true';
    this.dataset.enhanced = 'true';
    this.openHandle = null;

    this.closeAll();

    this.cards.forEach((card, index) => {
      card.addEventListener('click', () => this.toggle(card.dataset.doctorTab));
      card.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });
  }

  closeAll() {
    this.openHandle = null;

    this.cards.forEach((card) => {
      card.classList.remove('is-active');
      card.setAttribute('aria-expanded', 'false');
    });

    this.panels.forEach((panel) => {
      panel.classList.remove('is-active');
      panel.hidden = true;
    });
  }

  toggle(handle) {
    if (!handle) return;
    if (this.openHandle === handle) {
      this.closeAll();
      return;
    }

    this.openHandle = handle;

    this.cards.forEach((card) => {
      const active = card.dataset.doctorTab === handle;
      card.classList.toggle('is-active', active);
      card.setAttribute('aria-expanded', active ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const active = panel.dataset.doctorPanel === handle;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
  }

  onKeydown(event, index) {
    let next = null;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % this.cards.length;
    if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + this.cards.length) % this.cards.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = this.cards.length - 1;
    if (next === null) return;

    event.preventDefault();
    this.cards[next].focus();
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.cards[next].scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
  }
}

if (!customElements.get('ma-doctor-spotlight')) {
  customElements.define('ma-doctor-spotlight', MaDoctorSpotlight);
}
